import React from 'react';
import { useRecoilState } from 'recoil';
import {
  Box,
  Divider,
  IconButton,
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { maxDesignSpaceState, minDesignSpaceState } from 'features/optimization/state/appConfigAtoms';
import { isVisibleDesignSpaceState } from 'features/three-view/state/threeAtoms';
import { CustomTypography } from 'shared/ui/CustomTypography';
import { VectorForm } from 'features/morphing/components/forms/VectorForm';

interface Props {
  subtitle: string;
}

const iconSx = {
  fontSize: 12,
  color: '#e1e1e1'
};

export const DesignSpacePanel: React.FC<Props> = ({ subtitle }) => {
  const [isVisibleDesignSpace, setisVisibleDesignSpace] = useRecoilState(isVisibleDesignSpaceState);

  const handleToggle = () => {
    setisVisibleDesignSpace((prev) => !prev);
  };

  return (
    <Box component="div" sx={{ height: '100%', width: '100%' }}>

      <Box component="div" sx={{ display: 'flex', alignItems: 'center', height: '13%' }}>
        <CustomTypography >{subtitle}</CustomTypography>
        <IconButton onClick={handleToggle}>
          {isVisibleDesignSpace ? <VisibilityIcon sx={iconSx} /> : <VisibilityOffIcon sx={iconSx} />}
        </IconButton>
      </Box>

      <Divider sx={{ my: 0.5, bgcolor: '#e1e1e1' }} />

      <Box component="div">
        <VectorForm
          vectorState={minDesignSpaceState}
          label={"Min[mm]"}
          maxVectorState={maxDesignSpaceState}
          backgroundColor="#404040"
        />
      </Box>
      <Box component="div">
        <VectorForm
          vectorState={maxDesignSpaceState}
          label={"Max[mm]"}
          minVectorState={minDesignSpaceState}
          backgroundColor="#404040"
        />
      </Box>

    </Box>
  );
};
